import { useQuery } from '@tanstack/react-query'
import { RISK_PROFILE_QUERY_KEY, fetchProfileRisk } from '../services/riskProfile.service'
import type { ProfileRiskRequest } from '../types/riskProfile.types'

export function useRiskProfileQuery(request: ProfileRiskRequest | null) {
  return useQuery({
    queryKey: [RISK_PROFILE_QUERY_KEY, request],
    queryFn: () => {
      if (request === null) {
        throw new Error('Profile risk request is required')
      }

      return fetchProfileRisk(request)
    },
    enabled:
      request !== null &&
      (request.elements === undefined || request.elements.length > 0) &&
      (request.hazards === undefined || request.hazards.length > 0),
  })
}
